// 在庫不足フォームの数量上限（Issue #18）。サーバー（schema.ts）とウィジェット（index.ts）で同じ値を使う。
//
// DB の列は int（上限 2,147,483,647）で、超える値がそのまま届くと SQL Server で算術オーバーフローになり
// 400 ではなく 500 になる。int の上限で切るだけでも 500 は消えるが、それは「壊れないための上限」であって
// 「受け付ける数量」ではないので、現実の数量として上限を決めて 400 と読める理由を返す。
//
// 値の根拠（2026-09-12 本番 DB 実測・読み取りのみ）:
//   - 受注 OchanokoSalesRecodes 755,449 行（2008-08〜2026-09）の商品数量の最大は 515,000。
//     100,000 以上が 1,177 行、500,000 以上が 2 行、1,000,000 以上は 0 行
//   - 在庫台帳 在庫管理テーブル の 1 回の入出庫の最大は 9,691,064（物流センター入庫）
//   → 7 桁（9,999,999）なら、受注最大の約 19 倍・台帳の最大入庫より上で、int の 1/200。
//     1,000 万枚以上の相談は「フォーム」ではなく営業対応の領域なので、ここで止めて別途連絡してもらう
export const QUANTITY_MAX = 9_999_999
